import { type FormEvent, useState } from 'react';

import { liveConfigured, supabase } from './supabase';

export function AuthPage({ onDemo, onLive, logo }: { onDemo: () => void; onLive: () => void; logo: React.ReactNode }) {
  const [intent, setIntent] = useState<'sign-in' | 'sign-up'>('sign-in');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  async function submit(event: FormEvent) {
    event.preventDefault();
    if (!supabase) return;
    setBusy(true);
    setMessage(null);
    try {
      if (intent === 'sign-up') {
        const { data, error } = await supabase.auth.signUp({ email: email.trim(), password, options: { data: { display_name: name.trim() } } });
        if (error) throw error;
        if (!data.session) {
          setMessage('Check your email to confirm the account, then sign in.');
          setIntent('sign-in');
          return;
        }
      } else {
        const { error } = await supabase.auth.signInWithPassword({ email: email.trim(), password });
        if (error) throw error;
      }
      onLive();
    } catch (error) {
      setMessage(readableError(error));
    } finally {
      setBusy(false);
    }
  }

  return <main className="auth-shell">
    <div className="auth-card">{logo}<p className="eyebrow">Academy workspace</p><h1>{intent === 'sign-in' ? 'Welcome back.' : 'Start your academy.'}</h1>
      <p>{liveConfigured ? 'Sign in to manage your academy, or use the complete local demo.' : 'Supabase is not configured in this environment. The complete local demo remains available.'}</p>
      {liveConfigured && <form className="auth-form" onSubmit={submit}>
        {intent === 'sign-up' && <label>Display name<input required minLength={2} maxLength={80} autoComplete="name" value={name} onChange={(event) => setName(event.target.value)} /></label>}
        <label>Email<input required type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} /></label>
        <label>Password<input required minLength={8} type="password" autoComplete={intent === 'sign-in' ? 'current-password' : 'new-password'} value={password} onChange={(event) => setPassword(event.target.value)} /></label>
        {message && <p className="form-message" role="status">{message}</p>}
        <button className="button primary wide" disabled={busy}>{busy ? 'Please wait…' : intent === 'sign-in' ? 'Sign in' : 'Create account'}</button>
      </form>}
      <button className="button ghost wide" onClick={onDemo}>Enter working demo</button>
      {liveConfigured && <button className="text-link auth-switch" onClick={() => { setIntent(intent === 'sign-in' ? 'sign-up' : 'sign-in'); setMessage(null); }}>{intent === 'sign-in' ? 'New academy? Create an account' : 'Already have an account? Sign in'}</button>}
      <a className="text-link" href="/">Back to website</a>
    </div>
  </main>;
}

function readableError(error: unknown): string {
  if (typeof error === 'object' && error && 'message' in error) return String(error.message);
  return 'That did not work. Please try again.';
}

